import Router from '@/router/Router';
import Auth from '@/security/Authentication';
import Pages from '@/router/Pages';
import BasicLogin from "./BasicLogin";
import StorageManager from "./StorageManager";

let enableSecurity = process.env.VUE_APP_ENABLE_SECURITY == 'true';

if (enableSecurity) {
    Router.beforeEach((to, from, next) => {
        if (to.path !== "/cookieRequired" && !StorageManager.isEnableCookie()) {
            next({path: "/cookieRequired"});
            return;
        }

        if (to.path === "/cookieRequired" && StorageManager.isEnableCookie()) {
            next({path: "/home"});
            return;
        }

        let userAgent, ieReg, ie;
        userAgent = window.navigator.userAgent;
        ieReg = /msie|Trident.*rv[ :]*11\./gi;
        ie = ieReg.test(userAgent);

        if (ie) {
            if (to.path === Pages.browserSupportAlert.path) {
                next();
            } else {
                next({path: Pages.browserSupportAlert.path});
            }
            return;
        }

        let enableBasicLogin = process.env.VUE_APP_ENABLE_BASIC_LOGIN == 'true';
        if (enableBasicLogin && !BasicLogin.loggedIn() && to.path !== Pages.basicLogin.path && to.path !== "/cookieRequired") {
            console.log("basic login required")
            next(Pages.basicLogin.path);
            return;
        }

        let needAuthoritiesToViewPage = to.meta && to.meta.authorities && to.meta.authorities.length > 0;
        if (needAuthoritiesToViewPage) {
            if (Auth.hasAnyRoles(to.meta.authorities)) {
                /* has permission to access page */
                next();
            } else {
                if (!Auth.isAuthenticated()) {
                    StorageManager.setItem("requestUrl", to.fullPath)
                    console.log(to)
                    next(Pages.login.path);
                } else {
                    next(Pages.forbidden.path);
                }
            }
        } else {

            if (Auth.isAuthenticated() && to.path == Pages.login.path)
                next(Pages.redirect.path);

            // no authorities, so just proceed
            next();

        }
    });
} else {
    console.log("Disable security");
}
